<template>
	<v-row
		no-gutters
		dense
	>		
		<v-col>
			<v-carousel 
				hide-delimiters
			  	v-model = "slider"  			  							  	
				height  = "200"
			>
				<!-- 80 -->
			  	<v-carousel-item
			  	 	v-for = "(item_video, index_video) of listVideos"
					:key  = "index_video"
					class = "pa-0 ma-0"
				
				>
			
					<v-card 
						outlined 
					>
						<v-card-title 
							v-text = "$ml.get('video_evidence')"
							class  = "caption pa-0 ma-0 secondary white--text"
						>
						<!-- justify-center  -->
						</v-card-title>										
						<video  
							controls 
							width 	= "100%" 
							height 	= "100%" 
							preload = "auto" 
							:src 	= "item_video" 
							type 	= "video/mp4"
						></video>
					</v-card>
				</v-carousel-item>
			</v-carousel>
		</v-col>
	</v-row>
</template>
<script type="text/javascript">
	export default{
		name 	: "videoInformation",
		props 	: [ "info_to_component"],
		data 	: (vm) => ({
			informations 	: null,
			slider 			: 0,
			listVideos  	: [],
		}), // data
		watch: {
			info_to_component: function(val){
				if (val) {
					this.renderInfo(val);
				}
			}
		}, // watch
		methods : {
			renderInfo(item){
				if (item) {
					const constructedInfo = {};
					if (item.videos && item.videos.length > 0) {
						this.listVideos = item.videos;
					}
				}
			}, // renderInfo
			
		}, // methods
	}
</script>